(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["af-catalog-concept"] && !Shopify.designMode) return;
  try {
    

(()=>{function init(root){if(root.dataset.ready)return;root.dataset.ready='1';const data=JSON.parse(root.querySelector('[data-catalog]').textContent),items=data.items,results=root.querySelector('[data-results]'),cards=[...results.children],input=root.querySelector('#ac-search'),kind=root.querySelector('#ac-kind'),price=root.querySelector('#ac-price'),dialog=root.querySelector('dialog');let category='all';const norm=s=>s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');const synonyms={'nee zeggen':'pleasen|inslikken|grenzen met klanten','geld vragen':'je prijs noemen|geld en je familielijn','familiegeheimen':'familiegeheimen|gezwegen','voorouders':'voorouders|familielijn|kra','altijd voor anderen zorgen':'zorgen voor iedereen|altijd de sterke|alles zelf doen','grenzen':'pleasen|inslikken|grenzen|controle houden','burnout':'doorgaan|altijd alert|energielekken|overlevingsstand','burn-out':'doorgaan|altijd alert|energielekken|overlevingsstand'};function match(x,q){const text=norm(x.title+' '+(x.teaser||'')+' '+x.description+' '+x.categories.map(c=>data.categories.find(z=>z.id===c).title).join(' ')+' '+(x.names||[]).join(' '));const names=norm(x.title+' '+(x.names||[]).join(' '));return !q||(synonyms[q]?(synonyms[q].split('|').some(w=>names.includes(w))):text.includes(q))}function update(){const q=norm(input.value.trim());let n=0;items.forEach((x,i)=>{const show=match(x,q)&&(category==='all'||(category==='bundels'?x.kind==='bundel':x.categories.includes(category)))&&(kind.value==='all'||x.kind===kind.value)&&(price.value==='all'||x.price<=Number(price.value));cards[i].hidden=!show;if(show)n++});root.querySelector('[data-count]').textContent=n+' resultaten';root.querySelector('[data-empty]').hidden=n!==0;root.querySelector('[data-featured]').hidden=!!q||category!=='all'||kind.value!=='all'||price.value!=='all';root.querySelector('[data-result-heading]').textContent=category==='all'?'Alle cursussen en bundels':category==='bundels'?'Alle bundels':data.categories.find(c=>c.id===category).title;root.querySelectorAll('[data-cat]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.cat===category)))}input.addEventListener('input',update);kind.addEventListener('change',update);price.addEventListener('change',update);root.querySelectorAll('[data-cat]').forEach(b=>b.addEventListener('click',()=>{category=b.dataset.cat;update()}));root.querySelectorAll('[data-reset]').forEach(b=>b.addEventListener('click',()=>{input.value='';kind.value='all';price.value='all';category='all';update();input.focus()}));root.querySelectorAll('.ac-card').forEach(card=>{const trigger=card.querySelector('[data-detail]');if(!trigger)return;card.style.cursor='pointer';card.addEventListener('click',event=>{if(event.target.closest('button, a, input, select, textarea'))return;trigger.click()})});root.querySelectorAll('[data-detail]').forEach(b=>b.addEventListener('click',()=>{const x=items[Number(b.dataset.detail)],container=root.querySelector('[data-dialog-content]');container.replaceChildren();const heading=document.createElement('h2');heading.id='ac-dialog-title';heading.textContent=x.title;container.append(heading);const desc=document.createElement('p');desc.textContent=x.description;container.append(desc);if(x.names){const list=document.createElement('ul');x.names.forEach(n=>{const li=document.createElement('li');li.textContent=n;list.append(li)});container.append(list)}const cost=document.createElement('p');cost.textContent='€'+x.price+(x.total?' · los samen €'+x.total:'');container.append(cost);const form=document.createElement('form');form.method='post';form.action=(window.Shopify?.routes?.root||'/')+'cart/add';form.className='ac-purchase';const variant=document.createElement('input');variant.type='hidden';variant.name='id';variant.value=x.variant;const quantity=document.createElement('input');quantity.type='hidden';quantity.name='quantity';quantity.value='1';const destination=document.createElement('input');destination.type='hidden';destination.name='return_to';destination.value='/checkout';const buy=document.createElement('button');buy.type='submit';buy.textContent='Veilig afrekenen';form.append(variant,quantity,destination,buy);container.append(form);const note=document.createElement('p');note.className='ac-dialog-note';note.textContent='Dit is een digitale '+(x.kind==='bundel'?'cursusbundel':'cursus')+'. Er zijn geen verzendkosten. Na betaling krijg je automatisch toegang tot je cursus. Je ontvangt de toegangsinformatie per e-mail. Bestel met het e-mailadres waarop je de cursus wilt volgen.';container.append(note);dialog.showModal()}));dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()}});update()}document.querySelectorAll('[data-afiba-catalog]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-afiba-catalog]').forEach(init))})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-top"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modern-luku"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-luku]').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='true';
const strings=JSON.parse(root.querySelector('[data-luku-strings]').textContent),total=root.querySelector('[data-luku-total]'),mobile=root.querySelector('[data-luku-mobile-total]'),durationLabel=root.querySelector('[data-luku-mobile-duration]'),priceFormatter=new Intl.NumberFormat(document.documentElement.lang||'nl-NL',{style:'currency',currency:'EUR'});
function selectDuration(){const selected=root.querySelector('[name="luku_duration"]:checked');total.textContent=priceFormatter.format(Number(selected.dataset.price)/100);mobile.textContent=total.textContent;durationLabel.textContent=selected.value==='120'?strings.two:strings.one;root.querySelectorAll('[data-luku-panel]').forEach(panel=>panel.hidden=panel.dataset.lukuPanel!==selected.value);root.querySelector('[data-luku-external]').href='/products/kot-luku-bij-sisa-afiba?variant='+selected.dataset.variant+'&open_calendar=true';}
root.querySelectorAll('[name="luku_duration"]').forEach(radio=>radio.addEventListener('change',selectDuration));selectDuration();
});

  } catch(e) { console.error(e); }
})();
})();
